import $ from "jquery";
import { prefix } from "./globals/index"


class CardsInvolved {
    constructor() {
        this.cardOurSocialKit = $($(`.${prefix}-cards-involved .card-container .card`)[1]);

        this.cardOurSocialKit.on('click', (e) => {
            const href = $(e.target).attr('href');
            if (href === undefined || href === "") {
                e.preventDefault();
            } else if (href === "#") {
                this.openModalOurSocialKit();
            }
        });
    }


    openModalOurSocialKit = () => {
        const item = $('.vce-button--style-outline-animated').first();
        if (item)
            $(item).find('span').click();
    }

}

export {
    CardsInvolved
}
